import axios from "axios";

export const eventerApi = {
  get: async (resource, params = undefined, data = undefined, withCredentials = false) => {
    let request = {
      async: true,
      crossDomain: true,
      url: process.env.VUE_APP_BACKEND + resource,
      withCredentials: withCredentials,
      method: "get",
    };
    if (params) request = { ...request, params: params };
    if (data) request = { ...request, data: data };
    return await axios(request)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("Something went wrong: ", error.message);
      });
  },
  post: async (resource, params = undefined, data = undefined, withCredentials = false) => {
    let request = {
      async: true,
      crossDomain: true,
      url: process.env.VUE_APP_BACKEND + resource,
      withCredentials: withCredentials,
      method: "post",
    };
    if (params) request = { ...request, params: params };
    if (data) request = { ...request, data: data };
    return await axios(request)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("Something went wrong: ", error.message);
      });
  },
  put: async (resource, params = undefined, data = undefined, withCredentials = false) => {
    let request = {
      async: true,
      crossDomain: true,
      url: process.env.VUE_APP_BACKEND + resource,
      withCredentials: withCredentials,
      method: "put",
    };
    if (params) request = { ...request, params: params };
    if (data) request = { ...request, data: data };
    return await axios(request)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("Something went wrong: ", error.message);
      });
  },
  delete: async (resource, params = undefined, data = undefined, withCredentials = false) => {
    let request = {
      async: true,
      crossDomain: true,
      url: process.env.VUE_APP_BACKEND + resource,
      withCredentials: withCredentials,
      method: "delete",
    };
    if (params) request = { ...request, params: params };
    if (data) request = { ...request, data: data };
    return await axios(request)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("Something went wrong: ", error.message);
      });
  },
};
